import React from 'react';
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDownload} from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

const MargeLink = styled.a`
  margin-left: 10px;
`;

const DownloadInvoice = ({invoicePdf}) => {
  return (
    <MargeLink target="_blank" href={invoicePdf} className="btn-update" id="downloadButton" rel="noopener noreferrer">
      <FontAwesomeIcon icon={faDownload} color="#329aef" size="sm" />
    </MargeLink>
  );
};

DownloadInvoice.propTypes = {
  invoicePdf: PropTypes.string.isRequired,
};

export default DownloadInvoice;
